import authHeaders, { csrfToken } from "./authHeaders";

export const selectAuthHeaders = authHeaders
export const selectCsrfToken = csrfToken

export default {
  selectAuthHeaders,
  selectCsrfToken
}